import axios from 'axios'
// import { Message, MessageBox } from 'element-ui'
import store from '../store'
// import { getToken } from '@/utils/auth'
// var pra=queryString.parse(window.location.search)
   //   // 创建axios实例
   //     // service.defaults.baseURL=res.data.config,
   //
   //     // console.log(process.env.BASE_API);
   //   // console.log(store.state.config.axios_name);
     var service=axios.create({
		 headers: {
				// 'Cache-Control': 'no-cache'
		}
	
     });
	 // service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
	 // service.defaults.headers.post['Cache-Control'] = 'no-cache';
    //  service.defaults.baseURL='http://www.testhjdym.com/';
     service.defaults.baseURL='/';
     service.defaults.timeout=10000;
 // console.log(window.location.search);
  // 请求超时时间


// .then((res)=>{
//   console.log(res.data);
//   if(res.data.code==20000){
//     // this.$store.commit('SET_TOKEN', res.data.data.token);
//
//     // console.log("after find login");
//     // this.getseller();
//   }else {
//     // window.alert("没有当前商家名称")
//   }
// })
// const aname=store.state.config.axios_name;

// instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;

// request拦截器
service.interceptors.request.use(config => {
  var token=store.state.token;
  // if (store.getters.token) {
  // config.headers['authorization']='Bearer '+ token;
    config.headers['X-Token'] = token; // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非20000是抛错 可结合自己业务进行修改
  */
    const res = response.data
    // console.log(res);
    if (res.code !== 20000) {
        console.log('err-code='+res.code+" mes=" + res.data.message)
      // Message({
      //   message: res.data.message,//res.data,
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 20002 || res.code === 20001) {
        // MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '错误信息 ['+res.data.message+']', {
        //   confirmButtonText: '重新登录',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   store.dispatch('FedLogOut').then(() => {
        // location.hash='';
        location.reload()// 为了重新实例化vue-router对象 避免bug
        //   })
        // })
      }
      return Promise.reject('error')
    } else {
        // console.log(res.code);
        if(res.data.error){
          console.log('err-' + res.data.error)// for debug
          // Message({
          //   message: '返回错误='+res.data.error,//error.message,
          //   type: 'error',
          //   duration: 5 * 1000
          // })
          return Promise.reject(res.data.error)
        }else{
          return res;
        }
    }
  },
  error => {
    console.log('err-' + error)// for debug
    // Message({
    //   message: '网络状态错误 '+error,//error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service
